import { z } from "zod";
import { validarCpfCnpj } from "../../../../util/documento";

/**
 * Convenio de cobranca. Os valores vem do gerente do banco -
 * nao ha como deduzir nenhum deles.
 */
export const schema = z.object({
	id_boleto_config: z.number().int(),

	// Codigo Febraban: 1 = BB, 756 = Sicoob.
	banco: z.coerce.number().int().min(1, "Selecione o banco"),

	// Apelido do convenio. A empresa pode ter mais de um no mesmo
	// banco - sem isso a lista mostra "001" repetido.
	descricao: z.string().max(60).min(1, "Dê um nome para este convênio"),

	cedente_nome: z.string().max(100).min(1, "Preencha a razão social do beneficiário"),
	cedente_cnpj: z
		.string()
		.max(20)
		.min(1, "Preencha o CNPJ do beneficiário")
		.refine(validarCpfCnpj, "CPF/CNPJ inválido"),

	// Zero a esquerda importa: agencia "0123" nao e o mesmo que 123.
	// Por isso tudo string, nunca number.
	agencia: z.string().max(5).min(1, "Preencha a agência").regex(/^\d+$/, "Só números"),
	agencia_dv: z.string().regex(/^[0-9Xx]?$/, "Um número ou X"),
	conta: z.string().max(10).min(1, "Preencha a conta corrente").regex(/^\d+$/, "Só números"),
	conta_dv: z.string().regex(/^[0-9Xx]?$/, "Um número ou X"),

	// O TAMANHO do convenio muda o layout e quantas posicoes sobram
	// para o Nosso Numero. Nao normalizar.
	convenio: z.string().max(10).min(1, "Preencha o número do convênio").regex(/^\d+$/, "Só números"),
	codigo_cedente: z.string().max(15),

	carteira: z.string().max(3).min(1, "Preencha a carteira").regex(/^\d+$/, "Só números"),
	modalidade: z.string().max(3),

	// Sigla, nao codigo: o ACBr traduz DM -> 01, NP -> 02, etc.
	especie_doc: z
		.string()
		.max(3)
		.min(1, "Preencha a espécie")
		.regex(/^[A-Za-z]{2,3}$/, "Sigla de 2 ou 3 letras"),

	layout: z.coerce.number().int(),
	respon_emissao: z.string().max(10),

	// Faixa autorizada pelo banco. Emitir fora dela = registro recusado.
	nosso_numero_ini: z.coerce.number().int().min(1, "Mínimo 1").max(2147483647, "Máximo 2.147.483.647"),
	nosso_numero_fim: z.coerce.number().int().min(0).max(2147483647, "Máximo 2.147.483.647"),

	ambiente: z.string().max(10),
	ativo: z.boolean(),
}).superRefine((dados, ctx) => {
	if (dados.nosso_numero_fim !== 0 && dados.nosso_numero_fim <= dados.nosso_numero_ini) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			path: ["nosso_numero_fim"],
			message: "Deve ser maior que o inicial, ou 0 para sem limite",
		});
	}

	if (dados.banco === 1 && ![4, 6, 7].includes(dados.convenio.length)) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			path: ["convenio"],
			message: "Tamanho de convênio inválido para este banco",
		});
	}
});
